import {
    GetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryActionHistoryParams,
    GetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryInsiHistoryParams,
    InsiIdentityStatusIds,
    useGetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryActionHistory,
    useGetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryInsiHistory,
} from '@toktokdoctech/tokapi-client'
import { UsePatientFormModificationsHistory, UsePatientFormModificationsHistoryProps } from './_props'
import { HistoryRow } from '../components/Patient/Form/PatientFormModificationsHistory/_props'
import { checkIsHistoryActionType } from '../components/Patient/Form/_utils'
import { patientHistoryDetailToRowDetail } from '../components/Patient/Form/PatientFormModificationsHistory/_utils'

export const usePatientFormModificationsHistory = ({
    hcsId,
    patientId,
    isEditMode,
}: UsePatientFormModificationsHistoryProps): UsePatientFormModificationsHistory => {
    const historyParams: GetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryActionHistoryParams = { limit: 500 }
    const patientInsiParams: GetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryInsiHistoryParams = { limit: 500 }

    const defaultQueryOptions = {
        query: {
            enabled: isEditMode,
        },
    }
    const patientHistory = useGetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryActionHistory(
        hcsId,
        patientId,
        historyParams,
        defaultQueryOptions,
    )

    const patientInsiHistory = useGetIdsHealthcareservicesHcsIdPatientsPatientIdHistoryInsiHistory(
        hcsId,
        patientId,
        patientInsiParams,
        defaultQueryOptions,
    )

    const historyRows = patientHistory?.data?.items
        .filter((row) => row?.actionType)
        .map<HistoryRow>((item) => ({
            id: item.id,
            date: item.actionDate,
            label: item.updatedByLabel,
            actionType: checkIsHistoryActionType(item.actionType),
            actionDetails: item.actionDetails?.map((detail) => detail.fieldName),
            insiDetail: patientHistoryDetailToRowDetail(item?.actionInsiDetails ?? undefined),
        }))

    const insHistoryRows = patientInsiHistory?.data?.items.map<HistoryRow>((item) => ({
        id: '',
        date: item.statusDate,
        label: item.updatedBy ? `${item.updatedBy.firstName} ${item.updatedBy.lastName}` : undefined,
        insIndentityStatus: item.insiIdentityStatus.toUpperCase() as InsiIdentityStatusIds,
    }))

    const refetch = () => {
        patientHistory.refetch()
        patientInsiHistory.refetch()
    }

    return {
        historyRows,
        insHistoryRows,
        isHistoryLoading: patientHistory.isLoading,
        isInsiHistoryLoading: patientInsiHistory.isLoading,
        isHistoryError: patientHistory.isError,
        isInsiHistoryError: patientInsiHistory.isError,
        refetch,
    }
}
